import { setPromoCode } from "features/common/layouts/cartSlice";
import { getOnlyTLD, postFetcher } from "helpers/helper";
import { formatIDR } from "helpers/utils";
import { useState, useCallback } from "react";
import { Modal } from "react-bootstrap";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { notifyWarning, notifyError, notifyPromise, notifySuccess } from "components/ToastMessage";
// import style from "../../assets/scss/ModalPromoCode.module.scss"; // File sudah dihapus
import Spinner from "react-bootstrap/Spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

const ModalPromoCode = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const {
    productsList: cartItems,
    existingDomain,
    orderProcessName,
  } = useSelector((state) => state.cart);
  const { promoCode } = useSelector((state) => state.cart);
  const [promo, setPromo] = useState("");
  const [hasAutoApplied, setHasAutoApplied] = useState(false);

  // Check if Monitime product with annual+ billing cycle
  const isMonitimeWithAnnualPlus = cartItems.some(item => 
    item.pid === 1146 && 
    (item.billingcycle === "annually" || item.billingcycle === "biennially" || item.billingcycle === "triennially")
  );

  const inputCodeHandler = (e) => {
    setPromo(e.target.value);
  };

  const setPromoHandler = (e, code) => {
    e.preventDefault();
    setPromo(code);
  };

  // Function to check promo code for renew items
  const checkPromoCodeForRenew = async (renewItems, promoCodeToUse) => {
    try {
      // Extract hosting and domain renew items
      const hostingRenews = renewItems.filter(item => item.renewType === 'hosting');
      const domainRenews = renewItems.filter(item => item.renewType === 'domain');
      
      // Get product IDs from hosting renews
      const pids = hostingRenews
        .map(item => item.pid)
        .filter(pid => pid !== null && pid !== undefined)
        .join(',');
      
      // Get billing cycles from hosting renews - convert to lowercase and validate format
      const cycles = hostingRenews
        .map(item => {
          const cycle = item.cycles || item.billingcycle;
          if (!cycle) return null;
          
          // Convert to lowercase and validate format
          const normalizedCycle = cycle.toLowerCase();
          const validCycles = ['monthly', 'quarterly', 'semiannually', 'semi-annually', 'annually', 'biennially', 'triennially'];
          
          if (validCycles.includes(normalizedCycle)) {
            return normalizedCycle;
          }
          
          // Fallback to annually if invalid
          // console.warn(`Invalid billing cycle: ${cycle}, falling back to annually`);
          return 'annually';
        })
        .filter(cycle => cycle)
        .join(',');
      
      // Get domain extensions from domain renews
      const extensions = domainRenews
        .map(item => getOnlyTLD(item.domain))
        .filter(ext => ext)
        .join(',');
      
      // Get domain periods from domain renews - validate format
      const periods = domainRenews
        .map(item => {
          const period = item.periods || item.period || 1;
          if (!period) return null;
          
          // Extract number from period (e.g., "1Years" -> 1, "2Years" -> 2)
          const periodNumber = parseInt(period.toString().replace(/[^0-9]/g, '')) || 1;
          
          // Validate period range (1-10 years)
          if (periodNumber >= 1 && periodNumber <= 10) {
            return `${periodNumber}Years`;
          }
          
          // Fallback to 1 year if invalid
          // console.warn(`Invalid domain period: ${period}, falling back to 1Years`);
          return '1Years';
        })
        .filter(period => period)
        .join(',');
      
      const payload = {
        promo_code: promoCodeToUse,
        pid: pids || "",
        extensions: extensions || "",
        cycles: cycles || "",
        periods: periods || "",
        productname: "",
      };
      
      // console.log('Renew promo payload:', payload);
      // console.log('Renew items breakdown:', {
      //   hostingRenews: hostingRenews.map(item => ({
      //     type: item.renewType,
      //     pid: item.pid,
      //     cycles: item.cycles,
      //     billingcycle: item.billingcycle
      //   })),
      //   domainRenews: domainRenews.map(item => ({
      //     type: item.renewType,
      //     domain: item.domain,
      //     periods: item.periods,
      //     period: item.period
      //   }))
      // });
      
      const promoStatus = await postFetcher(
        process.env.REACT_APP_BASE_API + "order-api/api/v1/promotion/check", 
        payload
      );
      
      // console.log('Renew promo response:', promoStatus);
      
      const { code, error, data: details } = promoStatus;
      
      if (code !== 200) {
        // Handle nested error messages
        let errorMessage = "";
        
        if (error.message?.maxuses) {
          errorMessage = Array.isArray(error.message.maxuses) 
            ? error.message.maxuses[0] 
            : error.message.maxuses;
        } else if (error.message?.cycles) {
          errorMessage = Array.isArray(error.message.cycles) 
            ? error.message.cycles[0] 
            : error.message.cycles;
        } else if (error.message?.periods) {
          errorMessage = Array.isArray(error.message.periods) 
            ? error.message.periods[0] 
            : error.message.periods;
        } else if (error.message?.product) {
          errorMessage = Array.isArray(error.message.product) 
            ? error.message.product[0] 
            : error.message.product;
        } else if (error.message?.domain) {
          errorMessage = Array.isArray(error.message.domain) 
            ? error.message.domain[0] 
            : error.message.domain;
        } else if (error.message?.date) {
          errorMessage = Array.isArray(error.message.date) 
            ? error.message.date[0] 
            : error.message.date;
        } else if (error.message?.onceperclient) {
          errorMessage = Array.isArray(error.message.onceperclient) 
            ? error.message.onceperclient[0] 
            : error.message.onceperclient;
        } else if (typeof error.message === 'string') {
          errorMessage = error.message;
        } else {
          errorMessage = "Promo code tidak valid";
        }
        
        throw new Error(errorMessage);
      }
      
      // ✅ NEW: Validate that promo code is for renewal (must contain "renew" in description)
      // OR check if it's an upgrade voucher (has upgrades field)
      if (details) {
        // Check if this is an upgrade voucher first
        if (details.upgrades === '1' || details.upgrades === 1) {
          // This is an upgrade voucher - allow it
          // console.log(`Renew promo check: Promo code ${promoCodeToUse} is an upgrade voucher - allowing for renew`);
          return details;
        }
        
        // If not upgrade voucher, check if it's a renewal voucher
        if (details.description) {
          const description = details.description.toLowerCase();
          const isRenewalVoucher = description.includes('renew');
          
          if (!isRenewalVoucher) {
            // console.warn(`Renew promo check: Promo code ${promoCodeToUse} is not a renewal voucher. Description: '${details.description}' - must contain 'renew' keyword`);
            throw new Error(`Promo code ${promoCodeToUse} tidak dapat digunakan untuk perpanjangan layanan. Voucher ini hanya berlaku untuk layanan baru.`);
          }
          
          // console.log(`Renew promo check: Promo code ${promoCodeToUse} validated as renewal voucher. Description: '${details.description}'`);
        } else {
          // No description and not upgrade voucher - check if it has other valid fields
          if (details.type && details.price) {
            // Has type and price, might be a valid voucher without description
            // console.log(`Renew promo check: Promo code ${promoCodeToUse} has no description but appears valid - allowing`);
            return details;
          } else {
            // console.warn(`Renew promo check: Promo code ${promoCodeToUse} has insufficient data`);
            throw new Error(`Promo code ${promoCodeToUse} tidak valid atau tidak memiliki data yang diperlukan.`);
          }
        }
      } else {
        // console.warn(`Renew promo check: Promo code ${promoCodeToUse} has no details`);
        throw new Error(`Promo code ${promoCodeToUse} tidak valid atau tidak memiliki data yang diperlukan.`);
      }
      
      return details;
    } catch (error) {
      // console.warn('Renew promo check error:', error.message);
      throw error;
    }
  };

  const checkPromoCode = useCallback(async (promoCodeToCheck = null) => {
    try {
      if (cartItems.length === 0) {
        throw new Error("Tidak ada produk di dalam keranjang!");
      }

      // Check if cart contains renew items
      const hasRenewItems = cartItems.some(item => item.type === 'renew');
      
      if (hasRenewItems) {
        // Handle renew items for promo validation
        return await checkPromoCodeForRenew(cartItems, promoCodeToCheck || promo || promoCode.queryCode);
      }

      // Original logic for regular cart items
      let finalBillingCycle;
      const getItem = cartItems?.find((item) => item.pid);
      const getDomain = cartItems?.find((item) => item.domain);
      const prodBillingCycle = getItem?.billingcycle;
      const productPid = getItem?.pid ?? "";
      const domainName = getDomain?.name ?? existingDomain?.domain;
      const domainDuration = getDomain?.duration ?? 1;

      // Normalize billing cycle to lowercase and validate format
      if (prodBillingCycle) {
        const normalizedCycle = prodBillingCycle.toLowerCase();
        const validCycles = ['monthly', 'quarterly', 'semiannually', 'semi-annually', 'annually', 'biennially', 'triennially'];
        
        if (validCycles.includes(normalizedCycle)) {
          finalBillingCycle = normalizedCycle;
        } else {
          // console.warn(`Invalid billing cycle: ${prodBillingCycle}, falling back to annually`);
          finalBillingCycle = 'annually';
        }
      } else {
        finalBillingCycle = 'annually'; // Default fallback
      }

      // Handle semiannually special case
      if (finalBillingCycle === "semiannually") {
        finalBillingCycle = "semi-annually";
      }

      // Use provided promo code or fall back to state
      const promoCodeToUse = promoCodeToCheck || promo || promoCode.queryCode;

      const payload = {
        promo_code: promoCodeToUse,
        pid: productPid,
        extensions: getOnlyTLD(domainName),
        cycles: finalBillingCycle ?? "",
        periods: `${domainDuration}Years` || "",
        productname: "",
      };

      // console.log('Payload yang dikirim:', payload);
      const promoStatus = await postFetcher(process.env.REACT_APP_BASE_API + "order-api/api/v1/promotion/check", payload);
      // console.log('Respons dari server:', promoStatus);

      const { code, error, data: details } = promoStatus;

      if (code !== 200) {
        // Handle nested error messages
        let errorMessage = "";
        
        if (error.message?.maxuses) {
          errorMessage = Array.isArray(error.message.maxuses) 
            ? error.message.maxuses[0] 
            : error.message.maxuses;
        } else if (error.message?.cycles) {
          errorMessage = Array.isArray(error.message.cycles) 
            ? error.message.cycles[0] 
            : error.message.cycles;
        } else if (error.message?.periods) {
          errorMessage = Array.isArray(error.message.periods) 
            ? error.message.periods[0] 
            : error.message.periods;
        } else if (error.message?.product) {
          errorMessage = Array.isArray(error.message.product) 
            ? error.message.product[0] 
            : error.message.product;
        } else if (error.message?.domain) {
          errorMessage = Array.isArray(error.message.domain) 
            ? error.message.domain[0] 
            : error.message.domain;
        } else if (error.message?.date) {
          errorMessage = Array.isArray(error.message.date) 
            ? error.message.date[0] 
            : error.message.date;
        } else if (error.message?.onceperclient) {
          errorMessage = Array.isArray(error.message.onceperclient) 
            ? error.message.onceperclient[0] 
            : error.message.onceperclient;
        } else if (typeof error.message === 'string') {
          errorMessage = error.message;
        } else {
          errorMessage = "Promo code tidak valid";
        }
        
        throw new Error(errorMessage);
      }

      // ✅ NEW: Validate that promo code is for renewal (must contain "renew" in description)
      // OR check if it's an upgrade voucher (has upgrades field)
      if (details) {
        // Check if this is an upgrade voucher first
        if (details.upgrades === '1' || details.upgrades === 1) {
          // This is an upgrade voucher - allow it
          // console.log(`Regular promo check: Promo code ${promoCodeToUse} is an upgrade voucher - allowing`);
          return details;
        }
        
        // If not upgrade voucher, check if it's a renewal voucher (should be rejected for new products)
        if (details.description) {
          const description = details.description.toLowerCase();
          const isRenewalVoucher = description.includes('renew');
          
          if (isRenewalVoucher) {
            // console.warn(`Regular promo check: Promo code ${promoCodeToUse} is a renewal voucher but being used for new products. Description: '${details.description}'`);
            throw new Error(`Promo code ${promoCodeToUse} tidak dapat digunakan untuk layanan baru. Voucher ini hanya berlaku untuk perpanjangan layanan.`);
          }
          
          // console.log(`Regular promo check: Promo code ${promoCodeToUse} validated for new products. Description: '${details.description}'`);
        } else {
          // No description and not upgrade voucher - check if it has other valid fields
          if (details.type && details.price) {
            // Has type and price, might be a valid voucher without description
            // console.log(`Regular promo check: Promo code ${promoCodeToUse} has no description but appears valid - allowing`);
            return details;
          } else {
            // console.warn(`Regular promo check: Promo code ${promoCodeToUse} has insufficient data`);
            throw new Error(`Promo code ${promoCodeToUse} tidak valid atau tidak memiliki data yang diperlukan.`);
          }
        }
      } else {
        // console.warn(`Regular promo check: Promo code ${promoCodeToUse} has no details`);
        throw new Error(`Promo code ${promoCodeToUse} tidak valid atau tidak memiliki data yang diperlukan.`);
      }

      return details;
    } catch (error) {
      // console.warn(error.message);
      throw error;
    }
  }, [cartItems, promo, promoCode, existingDomain]);

  const usePromoCode = (e) => {
    e.target.disabled = true;
    if (promo === "CYBERMOVE20" && orderProcessName !== "migrasiHosting") {
      notifyError("Maaf, Promo berlaku hanya untuk Migrasi Hosting ");
      e.target.disabled = false;
      return;
    }

    const invalidDomain = cartItems.some((item) => {
      if (item.domain) {
          const tld = item.domain.split(".");
        const tldString = tld.length > 2 ? "." + tld[1] + "." + tld[2] : "." + tld[1];
        const domainName = tld[0];
        const result = tldString === ".web.id" && domainName.length === 2
        return result;
      }
      return false;
    });

    if (invalidDomain && (promo === "SEDEKAHID" || promo === "DOMAINBERKAH")) {
      notifyWarning("Tidak dapat menggunakan kode voucher ini untuk domain premium");
      return;
    }

    notifyPromise(checkPromoCode, {
      pending: "Checking promo code.",
      success: (data) => {
            e.target.disabled = false;
            dispatch(setPromoCode({ productsList: cartItems, promo, data }));
            setTimeout(() => {
              props.modalHandler(false);
            }, 1500);
            return data.message;
          },
      error: (data) => {
            e.target.disabled = false;
            return `${data}`;
      }
    });
  };

  useEffect(() => {
    if (location.pathname === "/paymentmethod" && promoCode.queryCode && props.show) {
      setPromo(promoCode.queryCode);
      notifyPromise(checkPromoCode, {
        pending: "Checking promo code.",
        success: (data) => {
              dispatch(setPromoCode({ promo: promoCode.queryCode, data }));
              setTimeout(() => {
                props.modalHandler(false);
              }, 1500);
              return data.message;
        }
      });
    }
  }, [checkPromoCode, dispatch, location.pathname, promoCode.queryCode, props, props.show]);

  // Check JAGAUPTIME voucher when modal is opened for Monitime with annual+ billing cycle
  useEffect(() => {
    if (isMonitimeWithAnnualPlus && props.show && !promoCode.queryCode && !promoCode.promo && !promoCode.code && !hasAutoApplied) {
      setHasAutoApplied(true);
      
      const checkJagauptime = async () => {
        try {
          const data = await checkPromoCode("JAGAUPTIME");
          dispatch(setPromoCode({ promo: "JAGAUPTIME", data }));
          // Don't show notification, just apply silently
        } catch (error) {
          // console.warn("Failed to check JAGAUPTIME:", error.message);
          setHasAutoApplied(false); // Reset if failed
        }
      };
      
      checkJagauptime();
    }
  }, [isMonitimeWithAnnualPlus, props.show, promoCode.queryCode, promoCode.promo, promoCode.code, hasAutoApplied, checkPromoCode, dispatch]);

  // Reset auto-applied state when modal is closed
  useEffect(() => {
    if (!props.show) {
      setHasAutoApplied(false);
    }
  }, [props.show]);

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      backdrop="static"
      size="lg"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="promoModalLabel">Pakai Promo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
         <div className="input-group">
           <input
             type="text"
             className={`form-control ${
               promo?.length > 2 ? "border border-danger" : ""
             }`}
             placeholder="Kode Voucher"
             id="voucherInput"
             aria-label="Kode Voucher"
             aria-describedby="btn-usePromo"
             value={promo}
             onChange={inputCodeHandler}
             style={{ 
               borderRadius: promo.length > 2 ? "0.5rem 0 0 0" : "0.5rem 0 0 0.5rem"
             }}
           />
           {promo.length > 2 && (
             <button
               className="btn btn-outline-danger fw-normal px-3"
               type="button"
               onClick={() => setPromo("")}
               title="Hapus kode voucher"
               style={{ 
                 borderRadius: "0",
                 borderLeft: "none",
                 borderRight: "none"
               }}
             >
               <FontAwesomeIcon 
                 icon={faTrash} 
                 style={{ fontSize: "14px" }}
               />
             </button>
           )}
           <button
             className="btn btn-cta fw-normal px-lg-5 px-1"
             type="button"
             id="btn-usePromo"
             disabled={promo?.length > 2 ? false : true}
             style={{ borderRadius: "0 0.5rem 0.5rem 0" }}
             onClick={usePromoCode}
           >
             Gunakan
           </button>
         </div>
        <div className="divider" style={{ height: "5px", backgroundColor: "#9c9c9c63", margin: "1em 0" }}></div>
        {promoCode.status === "loading" && (
          <div className="promo-wrapper mt-3">
            <h6 className="fw-bold mb-3">Promo yang bisa dipakai</h6>
            <Spinner animation="border" size="sm" />
          </div>
        )}
        {promoCode.status === "fulfilled" && (
          <>
            {promoCode.myVoucher === "Anda Belum Login" && (
              <div
                className="promo-wrapper mt-3"
                style={{ overflow: "auto", maxHeight: "430px" }}
              >
                <h6 className="fw-bold mb-3">Promo yang bisa dipakai</h6>
                <div className="card mb-3 rounded-4 shadow-sm">
                  <h5 className="mb-2 fw-bold text-center text-qw-primary py-5">
                    {promoCode.myVoucher}
                  </h5>
                </div>
              </div>
            )}
            {(promoCode.myVoucher !== "Anda Belum Login" && Array.isArray(promoCode.myVoucher) && promoCode.myVoucher.length === 0) ||
             (promoCode.myVoucher !== "Anda Belum Login" && !promoCode.myVoucher) ? (
              <div className="promo-wrapper mt-3">
                <h6 className="fw-bold mb-3">Promo yang bisa dipakai</h6>
                <h5 className="mb-2 fw-bold text-center text-qw-primary py-5">
                  Anda tidak memiliki promo atau promo Anda sudah kadaluarsa
                </h5>
              </div>
            ) : null}
            {promoCode.myVoucher !== "Anda Belum Login" && Array.isArray(promoCode.myVoucher) && promoCode.myVoucher.length > 0 && (
              <div
                className="promo-wrapper mt-3"
                style={{ overflow: "auto", maxHeight: "430px" }}
              >
                <h6 className="fw-bold mb-3">Promo yang bisa dipakai</h6>
                {promoCode.myVoucher.map((voucher, index) => (
                  <div key={voucher.code || index} className={`card mb-3 rounded-4 shadow-sm ${!voucher.isAvailable ? 'opacity-75' : ''}`}>
                    <div className="card-body p-3">
                      <div className="d-flex justify-content-between align-items-start mb-2">
                      <h6
                          className="mb-0 fw-bold text-qw-primary text-white py-1 px-1"
                        style={{
                          backgroundColor: "#ee4d30",
                          width: "fit-content",
                          borderRadius: "5px",
                        }}
                      >
                          {voucher.type === "Percentage" ? `${parseInt(voucher.value)}%` : formatIDR(voucher.value)}
                      </h6>
                        {voucher.source === 'hosting_voucher' && (
                          <span className="badge bg-info text-dark">Voucher Hosting</span>
                        )}
                      </div>
                      <h5 className="mb-3 fw-bold">{voucher.name}</h5>
                      
                      {/* Tampilkan info limit */}
                      {voucher.limitInfo && (
                        <div className={`small mb-2 ${voucher.isAvailable ? 'text-success' : 'text-danger'}`}>
                          <i className={`bi ${voucher.isAvailable ? 'bi-check-circle' : 'bi-x-circle'}`}></i>
                          {voucher.limitInfo}
                        </div>
                      )}
                      
                      {voucher.snk ? (
                        <p className="mb-2">
                          <span
                            dangerouslySetInnerHTML={{
                              __html: voucher.snk.split("\n").join("<br>"),
                            }}
                          ></span>
                        </p>
                      ) : null}
                      <div className="text-qw-primary fw-bold">
                        Berlaku hingga {voucher.expirationdate}
                      </div>
                      <div className="mb-3 mt-5">
                        <button
                          className={`btn rounded-5 px-4 py-1 ${voucher.isAvailable ? 'btn-cta' : 'btn-secondary'}`}
                          onClick={(e) => setPromoHandler(e, voucher.code)}
                          disabled={!voucher.isAvailable}
                          title={!voucher.isAvailable ? 'Voucher sudah mencapai batas penggunaan' : ''}
                        >
                          {voucher.isAvailable ? 'Pakai promo' : 'Tidak tersedia'}
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ModalPromoCode;
